<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="entry.lotNumber"
          v-bind="getObject('lotNumber')"
          label="Número"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <DateField
          :inputData.sync="entry.manufacturingDate"
          v-bind="getObject('manufacturingDate')"
          label="Data de Fabricação"
          :hasTodayButton="true"
          :hasTodayDate="false"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>  

      <v-col cols="12" sm="6">
        <DateField
          :inputData.sync="entry.dueDate"
          v-bind="getObject('dueDate')"
          label="Data de Validade"
          :hasTodayButton="true"
          :hasTodayDate="false"
          :disabled="readOnly"
          autocomplete="off"
        />
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"                   
          :inputData.sync="entry.packagingQuantity"
          mask-type="currency_10d"
          label="Quantidade de Embalagens"      
          @update:inputData="changePackagingQuantity"
          :disabled="readOnly"
          autocomplete="off"
          :suffix="packaging ? packaging.text : ''"
          :key="packagingQuantityKey + 'packagingQuantity'"
        />        
        <!--   -->
      </v-col>

      <v-col cols="12" sm="6">
        <MaskedTextField
          v-if="renderComponent"          
          v-bind="getObject('quantity')"
          :inputData.sync="entry.quantity"
          mask-type="currency_10d"
          label="Quantidade Unitária"
          :disabled="readOnly"
          @update:inputData="changeQuantity"
          autocomplete="off"
          :suffix="entry.item ? entry.item.unit.name : ''"
          :key="quantityKey + 'quantity'"
        />
        <!-- -->
      </v-col>
     
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import BaseUtil from "@shared_components/base_util.vue"
import DateField from "@shared_components/date_field.vue";

export default {
  data() {
    return {
      entryAttributes: {},      
      lotItemsList: [],
      renderComponent: true,
      itemsSearch: "",
      unitPriceKey: 0,
      totalPriceKey: 0,
      packagingQuantity: 0,
      packagingQuantityKey: 0,
      quantityKey: 0,
      packagingPriceKey: 0,
      pageLoading: false,
      interizator: 10000000000.0,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
    packaging: Object,
  },
  components: {
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
    DateField: DateField,
  },
  created() {
    // console.log("entry0", this.entry);
    this.entryAttributes = this.setupEntryAttributes(this.entry);
    // console.log("entryAttributes", this.entryAttributes);
    // console.log("item purchase", this.entry.item)
    if (this.entry.lotNumber) {
      // this.purchaseItemsList = [this.entry.item];
      // this.selectItem(false);
      this.changeQuantity();
    }

    // this.loadItemLots();
  },
  mounted() {
  },
  computed: {
    // itemTotalPrice: function() {
    //   this.entry.totalPrice = _.round((this.entry.price ? this.entry.price : 0) * (this.entry.quantity ? this.entry.quantity : 0), 2);
    //   return this.entry.totalPrice;
    // }
  },
  watch: {
    itemsSearch: function(newSearch, oldSearch) {
      // console.log("newSearch", newSearch, "oldSearch", oldSearch)
      // if (this.itemsSearch && this.itemsSearch.length > 0) {
      //   if (!this.entry.item || this.entry.item.name != this.itemsSearch) {
      //     this.getPurchaseItems();
      //   }
      // }
    }
  },
  methods: {
    changeQuantity: function() {
      // console.log("pkQtd", this.entry.packagingQuantity);
      this.entry.packagingQuantity = _.round( parseFloat(this.entry.quantity) / this.packaging.size, 10);
      this.packagingQuantityKey++;
      // this.updateQuantity();
    },    
    changePackagingQuantity: function() {            
      var temp = (Math.floor(this.entry.packagingQuantity * this.interizator) * this.packaging.size) / this.interizator;
      // console.log("temp", temp);
      this.entry.quantity = _.round(temp, 10);
      this.quantityKey++;
      // this.updateQuantity();
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },    
    clearFields: function() {
      this.forceRerender(this);
    },   
    selectItemLot: function(item){
      // console.log("item", item);
      for (let i in this.lotItemsList){
        // console.log("i", i);
        if(this.lotItemsList[i].id == item){
          this.setItemLot(this.lotItemsList[i]);
        }
      }      
    },
    setItemLot: function(itemLot){      
      if(itemLot){
        this.entry.name = itemLot.name;
        this.entry.lotNumber = itemLot.lotNumber;
        this.entry.manufacturingDate = itemLot.manufacturingDate;
        this.entry.dueDate = itemLot.dueDate;
        this.entry.availableQuantity = itemLot.availableQuantity;        
        this.entry.quantity = itemLot.quantity;
        // this.entry.packagingQuantity = this.packagingQuantity;
      }
    },
    itemCreated: function(item) {
      // console.log("item created", item)
      this.lotItemsList.unshift(item);
      this.entry.itemLotId = item.id;
      item.name = item.lotNumber+" F:"+ item.manufacturingDate+" V:"+item.dueDate;
      this.setItemLot(item);
      // console.log("item", item);
      // this.selectItem(true);
    },
  }
};



</script>

<style scoped></style>
